import { StrictMode, Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import '../../../packages/design-system/src/styles/index.css';
import './index.css';
import App from './App.tsx';
import { Provider } from 'react-redux';
import { store } from './app/store.ts';
import { initChunkErrorListener } from '@cointervue/shared';

initChunkErrorListener();

// Lazy pages
const PrivacyPolicyPage = lazy(() => import("./pages/PrivacyPolicyPage"));
const TermsOfUsePage = lazy(() => import("./pages/TermsOfUsePage"));
const DataPrivacyGuidelinesPage = lazy(
  () => import("./pages/DataPrivacyGuidelinesPage"),
);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <BrowserRouter>
         <Suspense>
          <Routes>
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms-of-use" element={<TermsOfUsePage />} />
            <Route
              path="/data-privacy-guidelines"
              element={<DataPrivacyGuidelinesPage />}
            />
            <Route
              path="/i/:token/*"
              element={<App />}
            />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </Provider>
  </StrictMode>,
)

